import { $translate } from '@/utils/i18n';
export default {
    'columnList': [
        {
            'prop': 'tenantCode',
            'label': $translate('lang.E3202103110001', { defaultText: '租户代码' })
        },
        {
            'prop': 'tenantName',
            'label': $translate('lang.E3202103110002', { defaultText: '租户名称' })
        },
        {
            'prop': 'accessKeyId',
            'label': $translate('lang.E3202103110003', { defaultText: '访问key' })
        },
        {
            'prop': 'accessKeySecret',
            'label': $translate('lang.E3202103110004', { defaultText: '访问秘钥' })
        },
        {
            'prop': 'endpoint',
            'label': $translate('lang.E3202103110005', { defaultText: 'OSS地址' })
        },
        {
            'prop': 'authUrl',
            'label': $translate('lang.E3202103110006', { defaultText: 'AUTH地址' })
        },
        {
            'prop': 'appUrl',
            'label': $translate('lang.E3202103110007', { defaultText: 'APP地址' })
        },
        {
            'prop': 'bucketName',
            'label': 'BUCKET'
        }
    ],
    'newOss': {
        'colList': [
            {
                'label': $translate('lang.E3202103110002', { defaultText: '租户名称' }),
                'formValues': 'tenantName',
                'disabled': true
            },
            {
                'label': $translate('lang.E3202103110003', { defaultText: '访问key' }),
                'formValues': 'accessKeyId',
                'disabled': false
            },
            {
                'label': $translate('lang.E3202103110004', { defaultText: '访问秘钥' }),
                'formValues': 'accessKeySecret',
                'disabled': false
            },
            {
                'label': $translate('lang.E3202103110005', { defaultText: 'OSS地址' }),
                'formValues': 'endpoint',
                'disabled': false
            },
            {
                'label': $translate('lang.E3202103110006', { defaultText: 'auth地址' }),
                'formValues': 'authUrl',
                'disabled': false
            },
            {
                'label': $translate('lang.E3202103110007', { defaultText: 'app地址' }),
                'formValues': 'appUrl',
                'disabled': false
            },
            {
                'label': $translate('lang.E3202103110016', { defaultText: 'bucket名字' }),
                'formValues': 'bucketName',
                'disabled': false
            }
        ]
    }
};